// Renders text with any http(s) URLs turned into clickable links (new tab).
const URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,!?;:'"])/g;

export function Linkify({ text, className = "", linkStyle }) {
  const str = String(text || "");
  const parts = str.split(URL_RE);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        /^https?:\/\//.test(p) ? (
          <a key={i} href={p} target="_blank" rel="noreferrer"
            className="underline break-words" style={{ color: "#2563eb", ...(linkStyle || {}) }}
            data-testid="chat-link">
            {p}
          </a>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </span>
  );
}
